import { BrianWordmark } from "@scribenote/brian-design-system";
import type { ReactNode } from "react";

export const AuthSheet = ({ children }: { children: ReactNode }) => (
  <div className="flex min-h-dvh bg-wall px-4 py-8 font-body text-ink sm:py-12">
    {/* m-auto centers the sheet and still lets a short viewport scroll it. */}
    <div className="m-auto flex w-full max-w-md flex-col items-center gap-6">
      <BrianWordmark mark={false} className="text-3xl" />
      <div className="w-full rounded-sheet border border-rule bg-card px-5 py-7 shadow-sheet sm:px-8 sm:py-8">
        {children}
      </div>
    </div>
  </div>
);
